import React from 'react';
import { photoUrl } from '../../data/photos';
import { InnerHeroActions, InnerHeroTrust } from './InnerHeroActions';

export const AboutHero = () => (
  <section className="inner-hero about-hero" data-testid="about-hero">
    <img className="inner-hero-photo" src={photoUrl('04')} alt="The Performance Lube 915 crew together outside the Gateway shop" fetchPriority="high" data-testid="about-hero-photo" />
    <div className="inner-hero-shade" aria-hidden="true" />
    <div className="site-container inner-hero-content">
      <h1 data-testid="about-title">MEET THE CREW<br /><em>BEHIND THE 915.</em></h1>
      <p className="inner-hero-subtitle" data-testid="about-hero-subtitle">Two El Paso shops. One crew. Every car treated like our own — that's the whole story.</p>
      <InnerHeroActions page="about" />
      <InnerHeroTrust page="about" />
    </div>
  </section>
);